import { Injectable } from '@angular/core';
import { CookieOptions, CookieService as cs } from 'ngx-cookie-service';
import {environment} from "../../environments/environment";

@Injectable({ providedIn: 'root' })
export class CookieService {
    constructor(private cookieService: cs) {}

    private getCookieDomains = (): Array<string | undefined> => {
        const cookieDomain = this.getCookie('domain_cookie');
        const configuredDomain = environment.openAmCookieDomain;
        const domains = [undefined, cookieDomain || undefined, configuredDomain || undefined, '.enelx.net', '.enelx.com'];
        return [...new Set(domains)];
    };

    private getWritableCookieDomain = (): string | undefined => {
        const domain = this.getCookie('domain_cookie') || environment.openAmCookieDomain;
        if (!domain || typeof window === 'undefined') return domain || undefined;

        const host = window.location.hostname;
        const normalizedDomain = domain.startsWith('.') ? domain.slice(1) : domain;
        const isMatchingDomain = host === normalizedDomain || host.endsWith(`.${normalizedDomain}`);

        return isMatchingDomain ? domain : undefined;
    };

    deleteCookie = (name: string, path?: string, domain?: string): void => {
        const targetPath = path ?? '/';
        if (domain) {
            this.cookieService.delete(name, targetPath, domain);
            return;
        }

        for (const cookieDomain of this.getCookieDomains()) {
            if (cookieDomain) {
                this.cookieService.delete(name, targetPath, cookieDomain);
            } else {
                this.cookieService.delete(name, targetPath);
            }
        }
    };

    getCookie = (cname: string): string => this.cookieService.get(cname);
    /**
     * Gets the brand value formatted for i18n
     */
    getI18NBrand = (): string => {
        const raw = this.getCookie('default_brand');
        if (!raw) {
            const fallback = environment.defaults.brand;
            this.setCookie('default_brand', fallback);
            return fallback.toUpperCase();
        }
        return raw.toUpperCase();
    };

    /**
     * Gets the locale cookie formatted for i18n
     */
    getI18NLocale = (): string => {
        const raw = this.getCookie('locale') || '';
        return raw.replace('_', '-').toLowerCase();
    };

    getSession = (): string => this.getCookie('enoc_session');

    setCookie = (name: string, value: string, days?: number | null, path?: string, domain?: string, secure?: boolean): void => {
        this.deleteCookie(name);

        const cookieOpts: CookieOptions = {
            path: path ?? '/',
            domain: domain ?? this.getWritableCookieDomain(),
        };
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            cookieOpts.expires = date;
        }
        if (secure !== undefined) {
            cookieOpts.secure = secure;
        }
        this.cookieService.set(name, value, cookieOpts);
    };


}
